<template>
  <v-card style="overflow-y: hidden;">
    <v-container>
      <v-row>
        <v-col cols="10" offset="1">
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col align="center">
                  <PageTitle :title="label('title')"/>
                </v-col>
              </v-row>
              <v-row>
                <PersonProfileForm v-model="data.person" />
              </v-row>
              <v-row v-if="completedMessage">
                <MessageBox type="success" :message="completedMessage"/>
              </v-row>
              <v-row v-if="errorMessage">
                <ErrorMessage :message="errorMessage"/>
              </v-row>
              <v-row>
                <v-col cols="6" :offset="saveButtonOffset">
                  <ActionButton type="save" @click="submit">
                    {{label("save")}}
                  </ActionButton>
                </v-col>
                <v-col cols="6" v-if="!hideCancel">
                  <ActionButton type="cancel" @click="onClose">
                    {{label("cancel")}}
                  </ActionButton>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import PageTitle from "../../atoms/PageTitle";
  import PersonProfileForm from "../../organisms/PersonProfileForm";
  import ActionButton from "../../molecules/ActionButton";
  import ErrorMessage from "../../molecules/ErrorMessage";
  import ComponentMixin from "../../ComponentMixin";
  import _clone from "lodash/clone"
  import {mapGetters} from "vuex";
  import MessageBox from "../../atoms/MessageBox";
  import ApiMixin from "../../../ApiMixin";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "PersonProfileEditPage",
    isRequiredLogin: true,
    data () {
      return {
        data: {
          person: {}
        },
        completedMessage: null,
        errorMessage: null,
      };
    },
    props: {
      close: {
        type: Function
      },
      hideCancel: {
        type: Boolean
      },
      open: {
        type: Boolean
      }
    },
    beforeMount () {
      this.init();
    },
    methods: {
      init () {
        this.data.person = _clone(this.person);
        this.data.person.email = this.user.email;
        this.completedMessage = null;
        this.errorMessage = null;
      },
      submit (e ,guard) {
        if (this.$refs.form.validate()) {
          guard((release) => {
            const user = _clone(this.user);
            if(this.data.person.email !== this.user.email){
              user.email = this.data.person.email;
            } else {
              delete user.email
            }
            this.saveUser(this.user.id, user).then(() => {
              this.saveBusiness(this.user, this.data.person).then(() => {
                this.close();
              }).catch(() => {
                this.errorMessage = this.label("failedChangeProfile");
              }).finally(release)
            }).catch( () => {
              this.errorMessage = this.label("failedChangeProfile");
            });
          }, false)
        } else {
          const dialog = document.getElementsByClassName("profileEditDialog")[0];
          if (this.data.person.lastName == null || this.data.person.lastName.length < 1 || this.data.person.firstName == null || this.data.person.firstName.length < 1 ) {
            dialog.scrollTop = document.getElementById('realName').offsetTop;
          } else if (this.data.person.lastNameKana == null || this.data.person.lastNameKana.length < 1 || this.data.person.firstNameKana == null || this.data.person.firstNameKana.length < 1 ) {
            dialog.scrollTop = document.getElementById('realNameKana').offsetTop;
          } else if (this.data.person.email == null || this.data.person.email.length < 1) {
            dialog.scrollTop = document.getElementById('email').offsetTop;
          } else if (this.data.person.tel == null || this.data.person.tel.length < 1) {
            dialog.scrollTop = document.getElementById('tel').offsetTop;
          }
        }
      },
      onClose () {
        this.init();
        this.close();
      }
    },
    computed: {
      ...mapGetters("user", ["user"]),
      ...mapGetters("client", ["person"]),
      saveButtonOffset () {
        if (this.hideCancel) {
          return 3;
        }
        return 0;
      }
    },
    components: {
      PageTitle,
      ErrorMessage,
      PersonProfileForm,
      ActionButton,
      MessageBox,
    },
    watch: {
      open: {
        handler: function(value) {
          if (value) {
            this.init();
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">

</style>
